import Swiper, { Navigation, Pagination } from 'swiper';

const plg = require("../autoload/functions-comunes");

export default {
  init() {
    // JavaScript to be fired on all pages
    setTimeout(function(){
      $('#loading').fadeOut(function(){
        $(this).remove();
      });
    },400);


    Swiper.use([Navigation, Pagination]);

    var swiper = new Swiper(".swiper-videos", {
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
    });


    $('#formContacto').submit(function (e) { 
      e.preventDefault();
      console.log('SUBMIT CONTACTO');

      var nombre = $('#nombre').val();
      var email = $('#email').val();
      var telefono = $('#telefono').val();
      var observaciones = $('#observaciones').val();
      
      //validar
      $('.has-error').removeClass('has-error');

      var error = false;
      if(nombre == ''){
        $('#nombre').parent().addClass('has-error');
        error = true;
      }
      if(email == '' || !plg.PLG_isEmail(email)){
        $('#email').parent().addClass('has-error');
        error = true;
      }
      if(telefono == ''){
        $('#telefono').parent().addClass('has-error');
        error = true;
      }
      if(!$('#legal').is(':checked')){
        $('#legal').parent().addClass('has-error');
        error = true;
      }
      
      if(!error){
        var data = $('#formContacto').serialize();
        $.ajax({
          type: "POST",
          url: "/wp-admin/admin-ajax.php",
          data: data,
          dataType: "json",
          success: function (response) {
            console.log(response);
            $('#nombre').val('');
            $('#email').val('');
            $('#telefono').val('');
            $('#observaciones').val('');
            $( "#legal" ).prop( "checked", false );
            plg.PLG_showModalAlerta('Gracias', 'Hemos recibido tus datos pronto te contactaremos con más informacion.');

          }
        });


      }else{
        plg.PLG_showModalAlerta('Error', 'Revisa los campos obligatorios.');
      }



    });


  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js